import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchProduct } from '../actions/ProductsCreators';
import Loading from '../components/loading';
import CategoryTreeSelect from '../containers/CategoryTreeSelect';
import CategoryUtils from '../common/CategoryUtils';
import fetcher from '../API/index';
import { message } from 'antd'

class PatchCategory extends Component {
    state = {
        newCategories: null,
        patchSucceed: false,
        patchFailed: false,
        isPatchNow: false,
        patchError: '',
    }

    componentDidMount() {
        const { id } = this.props.match.params;
        this.props.fetchProduct(id);
    }

    onCategoriesChanged = (value, nodeInfo) => {
        if(nodeInfo.length >= 1) {
            return message.error("只能选中三级类目！");
        }
        if(value.length > 1) {
            return message.error("只能选中一个类目！");
        }
        this.setState({
            newCategories: value,
        });
    }

    onSaveButtonClick = () => {
        const { newCategories } = this.state || {}
        if (!newCategories || !this.props.product.id) {
            return
        }
        this.setState({
            patchSucceed: false,
            patchFailed: false,
            patchError: '',
            isPatchNow: true,
        });

        fetcher.post(`/api/v1/products/${this.props.product.id}/manual`, {
            'categoryIds': newCategories,
        }).then((responese) => {
            // refresh the product info
            this.props.fetchProduct(this.props.match.params.id);
            this.setState({
                patchSucceed: true,
                isPatchNow: false,
            });
        }).catch((error) => {
            this.setState({
                patchFailed: true,
                patchError: error.response && error.response.data && error.response.data.errors,
                isPatchNow: false,
            });
        });;
    }

    render() {
        const { product } = this.props;
        const { patchSucceed, patchFailed, patchError, newCategories } = this.state;

        if (!product) {
            return <Loading />;
        }

        const categoryLabels = CategoryUtils.convertCategoryLables(product.categoryIds);

        return (
            <div className='container-fluid bg-light' style={{
                position: 'relative',
                minHeight: '500px',
                maxHeight: '1000px',
                overflowY: 'scroll'
            }}>
                <h3 className='mt-2'>Patch Product Category</h3>
                <hr />
                <div className='row'>
                    <div className="col-md-2">
                        <label className="label label-default">Product ID:</label>
                    </div>
                    <div className="col-md-10">
                        <span>
                            <strong> { product.id }</strong>
                        </span>
                    </div>
                </div>
                <div className='row'>
                    <div className="col-md-2">
                        <span className='label label-default'>Current Category:</span>
                    </div>
                    <div className="col-md-10">
                        <span>
                            <strong>{ categoryLabels.join() }</strong>
                        </span>
                    </div>
                </div>
                <div className='row mt-2'>
                    <div className="col-md-2">
                        <span className="label label-default">设置新的分类(Select New Category):</span>
                    </div>
                    <div className="col-md-10">
                        <CategoryTreeSelect 
                            selectedCategories={newCategories}
                            onChange={ this.onCategoriesChanged }
                            deprecateOldCategories={true}
                        />
                    </div>
                </div>

                { patchSucceed ? <div className="alert alert-success"> Patch Succeed!!</div> : null }
                { patchFailed ? <div className="alert alert-danger"> HTTP ERROR : { patchError } </div> : null }

                <div className="row mt-3">
                    <div className="col-md-2">
                        <button onClick={ this.onSaveButtonClick }
                            type="submit"
                            className="btn btn-info mb-2"
                        >Save</button>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    return {
        product: state.products.products[ownProps.match.params.id],
    };
}

export default connect(mapStateToProps, { fetchProduct })(PatchCategory);